import { LocationProvider } from '@/context/location.context';

const withLocation = (props) => {
  return <LocationProvider>{props.children}</LocationProvider>;
};

export default withLocation;
